/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiCirclePauseIcon16Light = forwardRef('MediaUiCirclePauseIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.5 4.5A.5.5 0 0 1 7 5v6a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M10 5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.004a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z" })));
});
